<template>
  <v-dialog
    v-model="dialog"
    width="330px">
    <div class="dialog-container">
      <el-form
        ref="send-form"
        :rules="rules"
        :model="sendFormData">
        <h3>{{isEmail}}</h3>
        <div class="form-item">
          <span>Customer</span>
          <div>
            <span>{{ form.isrd_nm }} {{ ` - ${form.mobile_no}` }}</span>
          </div>
        </div>
        <div class="form-item">
          <span>Content</span>
          <el-form-item prop="content">
            <v-input
              v-model="sendFormData.content"
              type="textarea"
              :rows="4" />
          </el-form-item>
        </div>
      </el-form>
      <div class="flex-sb-center">
        <div>
          <v-button @click="onCancel">Cancel</v-button>
        </div>
        <div>
          <v-button @click="onSkip">Skip</v-button>
          <v-button
            type="success"
            @click="onSend">Send</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
export default {
  name: 'SendEmailSmsDialog',
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    initContent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      sendFormData: {
        content: ''
      }
    }
  },
  computed:{
    isEmail(){
      let {customer={},identity} = this.form||{}
      return identity==2||customer.identity==2?'Send Email':'Send SMS'
    }
  },
  watch: {
    initContent: {
      immediate: true,
      handler(val, old) {
        if(val != old && !this.sendFormData.content) {
          this.sendFormData.content = val
        }
      }
    },
    dialog:{
      immediate: true,
      handler(val){
        // 关闭弹窗的时候清空发送内容
        if(!val){
          this.sendFormData.content = ''
        }
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    onCancel() {
      this.$emit('cancel')
    },
    onSend() {
      this.$refs['send-form'].validate((valid, rules) => {
        if(valid) {
          this.$emit('send', this.sendFormData)
          this.changeDialog()
        }
        else {
          console.log(rules)
        }
      })
    },
    onSkip() {
      this.$emit('skip')
      this.changeDialog()
    },
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      h3 {
        padding-bottom: 10px;
      }
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
      .form-item {
          & > span {
              font-weight: bold;
              font-size: 16px;
          }
      }
    }
</style>
